import { useNavigate } from "@tanstack/react-router";
import { UserRound } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import Button from "@/components/button";
import { useRole } from "@/utils/hooks/use-role";

function Chip({ title, text }: { title: string; text: string }) {
  return (
    <div className="w-20 h-20 rounded-sm p-2 bg-fog text-garnet flex flex-col gap-1 items-center">
      <p className="body-xs text-center">{title}</p>
      <p className="heading-2">{text}</p>
    </div>
  );
}

export function BusinessProfileCard({ business }: { business: any }) {
  const navigate = useNavigate();
  const role = useRole();
  const { t } = useTranslation("profile");

  return (
    <div className="w-full rounded-t-3xl bg-white min-h-[400px]">
      <div className="w-full flex flex-col items-center">
        <img
          src={business?.banner_image_url || "/assets/2025-09-04-23-36-14.png"}
          className="object-cover h-[124px] rounded-t-3xl aspect-[411/124]"
        />
        <Avatar className="-top-[20px] h-[65px] w-[65px]">
          <AvatarImage src={business?.image_url} />
          <AvatarFallback>
            <UserRound />
          </AvatarFallback>
        </Avatar>
      </div>
      <div className="w-full flex flex-col items-center gap-5 px-5">
        <div className="flex flex-col items-center">
          <h2 className="heading-2">{business?.name ?? ""}</h2>
          <p className="body-xs text-slate">{t("businessCard.activeSinceFallback")}</p>
        </div>
        <div className="grid grid-cols-4 gap-2 mt-[20px]">
          <Chip title={t("businessCard.responseTime")} text="2h" />
          <Chip title={t("businessCard.shiftsActive")} text="2h" />
          <Chip title={t("businessCard.shiftsCompleted")} text="2h" />
          <a href={`/app/profile/employer/${business.id}/ratings`} className="">
            <Chip title={t("businessCard.rating")} text={String(business?.total_reviews ?? "")} />
          </a>
        </div>
        <p className="body-small">
          {business?.description ?? t("businessCard.noDescription")}
        </p>
        <div className="w-full h-[1px] bg-[#545A6340] mt-5" />
        <Button
          variant="secondary"
          onClick={() =>
            navigate({
              to: "/app/$role/messages",
              params: { role },
              search: {
                tab: "messages",
                to: business.user_id,
                businessId: business.id,
                selectedOfferId: undefined,
              },
            })
          }
        >
          {t("businessCard.sendMessage")}
        </Button>
      </div>
    </div>
  );
}
